import { api } from './client';
import type { BingDateGrain } from './bingDashboard';
import type { GoogleReportRow } from './googleDashboard';
import type { AppLikeOverviewParams, AppLikeOverviewResponse } from './applovinDashboard';

export type SnapchatReportType = 'overview' | 'new_old' | 'detail';
export type SnapchatReportRow = GoogleReportRow;

export interface SnapchatReportResponse {
  list: SnapchatReportRow[];
  summary: SnapchatReportRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: SnapchatReportType;
}

export interface SnapchatReportParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
  report: SnapchatReportType;
  dimensions?: string;
  target_type?: string;
  new_old_type?: string;
  ad_form_type?: string;
  bid_type?: string;
  material_type?: string;
  directory_type?: string;
  price_type?: string;
  audience_type?: string;
  loading_page_type?: string;
  customer_type?: string;
  account_name?: string;
  campaign_name?: string;
  adset_name?: string;
  ad_name?: string;
}

export interface VooglamSnapOverviewParams extends AppLikeOverviewParams {
  dimensions?: string;
  country?: string;
}

type ApiEnvelope<T> = { code: number; data: T; message?: string };

export const snapchatDashboardApi = {
  getReport: (params: SnapchatReportParams) =>
    api.get<ApiEnvelope<SnapchatReportResponse>>('/ad-dashboard/snapchat/report', { params }),
  getVooglamOverview: (params: VooglamSnapOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/snapchat/overview', { params }),
  getVooglamTrend: (params: AppLikeOverviewParams) =>
    api.get<ApiEnvelope<AppLikeOverviewResponse>>('/ad-dashboard/snapchat/trend', { params }),
};
